import React, { use, useEffect, useRef, useState } from "react";
import { getIntegrations as getIntegrationsService, getIntegrationByName, fetchGoogleSheetsData } from "../../services/integrations";
import { Modal, Form } from "react-bootstrap";
import { X, Link, Tag, CircleX, Check, Loader2 } from "lucide-react";
import "./DocumentModal.css";
import {
  scrapReferenceUrl,
  scrapIndex,
  uploadFilesToApi,
  convertFileToBase64,
} from "../../utils/Product";
import axiosInstance from "../../utils/api";
import { uploadFilesToFouray } from "../../services/diyAgentService";
import { useLocation, useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getFileIcon } from "../../utils/Product";
import { template } from "handlebars";
import Select from "react-select";
import BlogTypeModal from "../GenerateBlog/BlogTypeModal";
import { useCompany } from "../../context/CompanyContext";
import { getShopifyPage } from "../../services/freeFormContentService";
import { toast } from "react-toastify";

const DocumentModal = ({
  show,
  onHide,
  initialTags,
  initialDocList,
  sku,
  previewUrl,
  productData,
  templateId,
  previewImage,
  templateName,
  blogData,
  companyKnowledgeDocs = [],
  groupedDocuments = [],
  editingRowData = null,
  agentName = null, // For DIY agents
  agentData = null, // Full agent data for DIY agents (to access folder ID)
}) => {
  const { companyId, loadGeneratedContents } = useCompany();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [tags, setTags] = useState(initialTags || "");
  const [tagList, setTagList] = useState(initialDocList || []);
  const [docList, setDocList] = useState(initialDocList || []);
  const [referenceUrl, setReferenceUrl] = useState("");
  const [isScrapingLoading, setIsScrapingLoading] = useState(false);
  const [scrapingSuccess, setScrapingSuccess] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = React.useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [uploadedFiles1, setUploadedFiles1] = useState([]);
  const [uploadedFiles2, setUploadedFiles2] = useState([]);
  const formattedSku = (sku || "").trim().replace(/\s+/g, "_");
  const formatedTemplateName = (templateName || "").trim().replace(/\s+/g, "_");
  const [referenceUrls, setReferenceUrls] = useState([""]);
  const [scrapingLoadingArr, setScrapingLoadingArr] = useState([false]);
  const [scrapingSuccessArr, setScrapingSuccessArr] = useState([false]);
  const [showBlogTypeModal, setShowBlogTypeModal] = useState(false);
  const [blogTypeModalData, setBlogTypeModalData] = useState(null);
  const [uid, setUid] = useState("");
  const [isScrapingForEdit, setIsScrapingForEdit] = useState(false);
  const [expandedGroups, setExpandedGroups] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedIntegration, setSelectedIntegration] = useState('');
  const [integrations, setIntegrations] = useState([]);
  const [isLoadingIntegration, setIsLoadingIntegration] = useState(false);
  const [showFieldValidation, setShowFieldValidation] = useState(false);

  const allUploadedFiles = [...uploadedFiles1, ...uploadedFiles2];

  // Integration options (fetched from API)
  const [integrationOptions, setIntegrationOptions] = useState([]);
  useEffect(() => {
    const fetchIntegrationOptions = async () => {
      const apiItems = await getIntegrationsService();
      const options = apiItems.map((item) => ({
        value: String(item.name || '').toLowerCase().replace(/\s+/g, '_'),
        label: item.name || ''
      }));
      setIntegrationOptions(options);
    };
    fetchIntegrationOptions();
  }, []);

  // Dynamic integration configuration API
  const getIntegrationConfig = async (integrationType) => {
    // Map selected value to display name used by the API
    const selected = integrationOptions.find(opt => opt.value === integrationType);
    const nameForApi = selected?.label || integrationType;
    const data = await getIntegrationByName(nameForApi);
    if (!data) return null;

    // Start with fields from notes
    let fields = Array.isArray(data?.notes?.fields) ? [...data.notes.fields] : [];

    // If API provides actions array, ensure an 'action' select exists and populate options from actions
    if (Array.isArray(data.actions) && data.actions.length > 0) {
      const actionIndex = fields.findIndex(f => f.id === 'action');
      const actionOptions = data.actions.map(a => ({ label: a, value: a }));
      if (actionIndex >= 0) {
        fields[actionIndex] = {
          ...fields[actionIndex],
          type: 'select',
          options: actionOptions,
          required: fields[actionIndex].required ?? true,
        };
      } else {
        fields.unshift({
          id: 'action',
          type: 'select',
          label: 'Select Action',
          options: actionOptions,
          required: true,
        });
      }
    }

    return {
      integration_type: data.name,
      fields,
    };
  };

  // Handle integration selection from dropdown
  const handleIntegrationSelect = (selectedOption) => {
    setSelectedIntegration(selectedOption?.value || '');
  };

  // Handle configure button click
  const handleConfigureIntegration = async () => {
    if (!selectedIntegration) return;

    setIsLoadingIntegration(true);
    
    try {
      const config = await getIntegrationConfig(selectedIntegration);
      
      // Initialize form fields with empty values
      const initialFields = {};
      config.fields.forEach(field => {
        initialFields[field.id] = field.type === 'select' ? '' : '';
      });

      // Add new integration to the list
      const newIntegration = {
        id: Date.now(), // Simple ID generation
        type: selectedIntegration,
        config: config,
        fields: initialFields
      };

      setIntegrations(prev => [...prev, newIntegration]);
      setSelectedIntegration(''); 
    } catch (error) {
      console.error('Error fetching integration config:', error);
    } finally {
      setIsLoadingIntegration(false);
    }
  };

  // Handle integration field changes
  const handleIntegrationFieldChange = (integrationId, fieldId, value) => {
    setIntegrations(prev => 
      prev.map(integration => 
        integration.id === integrationId 
          ? {
              ...integration,
              fields: {
                ...integration.fields,
                [fieldId]: value
              }
            }
          : integration
      )
    );
    // Hide validation when user starts typing
    if (showFieldValidation) {
      setShowFieldValidation(false);
    }
  };

  // Remove specific integration
  const removeIntegration = (integrationId) => {
    setIntegrations(prev => prev.filter(integration => integration.id !== integrationId));
  };

  // Check if all required fields are filled for an integration
  const isIntegrationValid = (integration) => {
    if (!integration.config?.fields) return true;
    
    return integration.config.fields.every(field => {
      if (!field.required) return true;
      const fieldValue = integration.fields[field.id];
      return fieldValue && fieldValue.toString().trim() !== '';
    });
  };

  // Check if all integrations are valid
  const areAllIntegrationsValid = () => {
    return integrations.every(integration => isIntegrationValid(integration));
  };

  // Toggle group expansion
  const toggleGroup = (groupName) => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName]
    }));
  };

  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);
  const dropdownRef = useRef(null);
  
  // Determine the current flow type
  const isEmailFlow = location.pathname === "/skills/email/email-template";
  const isBlogFlow = location.pathname.includes("/skills/blog");
  const isFreeFormContentFlow = location.pathname.includes("/skills/free-form-content");
  const isChatFlow = location.pathname.includes("/skills/chat");
  const isDiyAgentFlow = agentName !== null && agentName !== undefined;
  
  const { getRootProps: getRootProps1, getInputProps: getInputProps1 } =
    useDropzone({
      accept: ".pdf,.txt,.doc,.csv,.png,.jpg,.jpeg",
      onDrop: (acceptedFiles) => {
        setUploadedFiles1((prevFiles) => [...prevFiles, ...acceptedFiles]);
      },
    });

  const generateUID = () => {
    const timestamp = Date.now().toString();
    const randomPart = Math.random().toString(36).substring(2, 6);
    const newUID = `${timestamp}-${randomPart}`;
    setUid(newUID);
    return newUID;
  };

  const { getRootProps: getRootProps2, getInputProps: getInputProps2 } =
    useDropzone({
      accept: ".pdf,.txt,.doc,.csv,.png,.jpg,.jpeg",
      onDrop: (acceptedFiles) => {
        setUploadedFiles2((prevFiles) => [...prevFiles, ...acceptedFiles]);
      },
    });
  useEffect(() => {
    if (initialTags) {
      setTagList(initialTags.split(",").map((tag) => tag.trim()));
    }
  }, [initialTags]);
  useEffect(() => {
    if (show) {
      setUploadedFiles1([]); // Clear files only when modal fully closes
      setUploadedFiles2([]);
      // Reset document selections when modal opens
      setDocList(initialDocList ? initialDocList.split(",").map((doc) => doc.trim()) : []);
      // Reset tags when modal opens
      setTagList(initialTags ? initialTags.split(",").map((tag) => tag.trim()) : []);
      setTags(initialTags || "");
      // Reset reference URLs
      setReferenceUrls([""]);
      setScrapingLoadingArr([false]);
      setScrapingSuccessArr([false]);
      // Reset dropdown states
      setSearchTerm('');
      setIsDropdownOpen(false);
      setHoveredItem(null);
      setExpandedGroups({});
      // Call generated content API every time modal opens
      if (loadGeneratedContents) {
        loadGeneratedContents();
      }
    } else {
      setSelectedIntegration('');
      setIntegrations([]);
      setShowFieldValidation(false);
      // Reset all selections when modal closes
      setDocList([]);
      setTagList([]);
      setTags("");
      setReferenceUrls([""]);
      setScrapingLoadingArr([false]);
      setScrapingSuccessArr([false]);
      setSearchTerm('');
      setIsDropdownOpen(false);
      setHoveredItem(null);
      setExpandedGroups({});
    }
  }, [show, loadGeneratedContents, initialDocList, initialTags]);
  useEffect(() => {
    if (initialDocList)
      setDocList(initialDocList.split(",").map((doc) => doc.trim()));
  }, [initialDocList]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
        setSearchTerm(''); // Clear search when closing
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const shortenFileName = (fileName) => {
    return fileName.length > 10 ? `${fileName.slice(0, 10)}...` : fileName;
  };

  const getFileSize = (file) => {
    return (file.size / 1024).toFixed(2) + " KB";
  };

  const handleTagInput = (event) => {
    if (event.key === "Enter" && tags.trim()) {
      setTagList((prevTags) => [...prevTags, tags.trim()]);
      setTags("");
    }
  };

  const handleRemoveTag = (index) => {
    const newTags = tagList.filter((_, i) => i !== index);
    setTagList(newTags);
  };

  const openFileDialog = (fileInputRef) => {
    fileInputRef.current?.click();
  };
  const handleFileSelect = (event, setUploadedFiles) => {
    const selectedFiles = Array.from(event.target.files);

    setUploadedFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    event.target.value = null;
  };
  const handleRemoveFile1 = (index, setUploadedFiles1) => {
    setUploadedFiles1((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  const handleRemoveFile2 = (index, setUploadedFiles2) => {
    setUploadedFiles2((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const handleScrapAtIndex = async (idx) => {
    if (!referenceUrls[idx]) return;
    const newLoading = [...scrapingLoadingArr];
    const newSuccess = [...scrapingSuccessArr];
    newLoading[idx] = true;
    newSuccess[idx] = false;
    setScrapingLoadingArr(newLoading);
    setScrapingSuccessArr(newSuccess);
  
    let generatedUID = uid || generateUID();
  
    let payload = {};
    if (isEmailFlow) {
      payload = {
        request_type: "email",
        additional_data: {
          tags: [],
          template: formatedTemplateName || "",
          url: referenceUrls[idx],
          uid: generatedUID,
        },
      };
    } else if (isBlogFlow) {
      payload = {
        request_type: "Blog",
        additional_data: {
          tags: [],
          documents: docList,
          url: referenceUrls[idx],
          uid: generatedUID,
          // company_id: companyId ,
        },
      };
    } else if (isFreeFormContentFlow) {
      payload = {
        request_type: "free_form",
        additional_data: {
          tags: tagList,
          documents: docList,
          url: referenceUrls[idx],
          uid: generatedUID
        },
      };
    } else if (isChatFlow) {
      payload = {
        request_type: "chat",
        additional_data: {
          tags: tagList,
          url: referenceUrls[idx],
          uid: generatedUID,
        },
      };
    } else {
      payload = {
        request_type: "product_description_web_upload",
        additional_data: {
          tags: tagList.join(", "),
          sku: sku || "",
          url: referenceUrls[idx],
        },
      };
    }
  
    let success = false;
    for (let attempt = 1; attempt <= 3; attempt++) {
      try {
        await scrapReferenceUrl(payload);
        newSuccess[idx] = true;
        success = true;
        break; 
      } catch (e) {
        console.error(`Attempt ${attempt} failed for index ${idx}`, e);
        if (attempt === 3) {
          newSuccess[idx] = false; // after 3 failures mark as failed
        }
        }
      }
  
    newLoading[idx] = false;
    setScrapingLoadingArr([...newLoading]);
    setScrapingSuccessArr([...newSuccess]);
  };

  // Reusable function for scraping and navigation
  const handleScrapingAndNavigate = async (generatedUID, isEditFlow = true, shouldScrape = false) => {
    try {
      if (editingRowData) {
          const pageUrl = editingRowData.page_url;
          let scrapedData = null;
          
          if (pageUrl && shouldScrape) {
            setIsScrapingForEdit(true);
            toast.info('Starting to scrape page content...');
            
            let scrapingSuccess = false;
            let lastError = null;
            
            for (let attempt = 1; attempt <= 3; attempt++) {
              try {
                const payload = {
                  request_type: "free_form",
                  additional_data: {
                    documents: docList,
                    url: pageUrl,
                    uid: generatedUID,
                  },
                };
                console.log(`Scraping attempt ${attempt} for URL:`, pageUrl);
                scrapedData = await scrapReferenceUrl(payload);
                console.log('Scraping response:', scrapedData);
                
                // Check if the response indicates success
                if (scrapedData && (scrapedData.message || scrapedData.success !== false)) {
                  scrapingSuccess = true;
                  toast.success('Page content scraped successfully!');
                  break;
                } else {
                  throw new Error('Scraping response did not indicate success');
                }
              } catch (scrapError) {
                console.warn(`Scraping attempt ${attempt} failed:`, scrapError);
                lastError = scrapError;
                
                if (attempt < 3) {
                  const waitTime = attempt * 1000; // 1s, 2s, 3s
                  console.log(`Waiting ${waitTime}ms before retry...`);
                  await new Promise(resolve => setTimeout(resolve, waitTime));
                }
              }
            }
            setIsScrapingForEdit(false);
            
            if (!scrapingSuccess) {
              const errorMessage = `Failed to scrape page after 3 attempts. Last error: ${lastError?.message || 'Unknown error'}`;
              console.error('Scraping failed completely:', errorMessage);
              toast.error('Failed to scrape page content. Please try again or contact support.');
              return; // Don't navigate if scraping failed
            }
          }
          
          // Define transformedData after scraping is complete
          const transformedData = {
            ...editingRowData,
            is_shopify_page: true,
            name:  editingRowData.name,
            title: editingRowData.title,
            generated_content: editingRowData.body_html || editingRowData.generated_content || '',
            shop_id: editingRowData.shop_id,
            handle: editingRowData.handle,
            page_url: pageUrl,
            template_suffix: editingRowData.template_suffix,
            admin_graphql_api_id: editingRowData.admin_graphql_api_id,
            metafields: editingRowData.metafields,
            fetched_from_api: true,
            scraped_data: scrapedData,
            tags: tagList.join(", "),
            documents: docList,
            uid: generatedUID,
            uploadedFiles: allUploadedFiles,
          };
          
          // Only close the modal and navigate after scraping is complete
          onHide();
          navigate('/skills/free-form-content/edit', { 
            state: { 
              contentData: transformedData, 
              generated_content: transformedData.generated_content 
            } 
          });
      } else {
        // Handle regular free form content edit
        const editData = {
          ...editingRowData,
          // Include document upload data
          tags: tagList.join(", "),
          documents: docList,
          uid: generatedUID,
          uploadedFiles: allUploadedFiles,
        };
        
        // Close the modal and navigate
        onHide();
        navigate('/skills/free-form-content/edit', { 
          state: { 
            contentData: editData 
          } 
        });
      }
    } catch (error) {
      console.error('Error in edit flow:', error);
      toast.error('An error occurred during processing. Please try again.');
      setIsScrapingForEdit(false);
    }
  };

  
  const handleFileUpload = async () => {
    // Check if there are integrations and validate them
    if (integrations.length > 0 && !areAllIntegrationsValid()) {
      setShowFieldValidation(true);
      toast.error('Please fill all required fields in the integrations');
      return;
    }
    
    setShowFieldValidation(false);
    setIsUploading(true);
    let generatedUID = "";
    if (!uid) {
      generatedUID = generateUID();
    } else {
      generatedUID = uid;
    }

    const formData = new FormData();
    console.log(allUploadedFiles);

    allUploadedFiles.forEach((file) => {
      formData.append("file[]", file);
    });

    // Get resource info from selected generated content documents
    const resourceInfo = getResourceInfo();
    if (resourceInfo) {
      formData.append("resource_type", resourceInfo.resource_type);
      formData.append("resource_id", resourceInfo.resource_id);
    }

    // Filter documents to only include knowledge base documents
    const knowledgeBaseDocuments = docList.filter(selectedValue => {
      const doc = docOptions
        .flatMap(group => group.options || [])
        .find(option => option.value === selectedValue);
      return doc && doc.source === 'knowledge_base';
    });

    // For DIY agents, use agent name with underscores as request_type
    const agentNameForApi = agentName ? agentName.replace(/\s+/g, '_') : null;
    
    const jsonPayload = {
      request_type: isDiyAgentFlow
        ? agentNameForApi
        : isEmailFlow
        ? "email"
        : isBlogFlow
        ? "blog"
        : isFreeFormContentFlow
        ? "free_form"
        : isChatFlow
        ? "free_chat"
        : "product_description",
      
      additional_data: isDiyAgentFlow
        ? {
            
            documents: knowledgeBaseDocuments,
            uid: generatedUID,
          }
        : isEmailFlow
        ? {
            template: formatedTemplateName || "",
            tags: tagList,
            uid: generatedUID,
            documents: knowledgeBaseDocuments,
          }
        : isBlogFlow
        ? {
            tags: tagList,
            documents: knowledgeBaseDocuments,
            uid: generatedUID,
           // company_id: companyId,
          }
        : isFreeFormContentFlow
        ? {
            tags: tagList,
            documents: knowledgeBaseDocuments,
            uid: generatedUID,
          }
        : isChatFlow
        ? {
            tags: tagList,
            documents: knowledgeBaseDocuments,
            uid: generatedUID,
          }
        : {
            sku: sku || "",
            tags: tagList,
            documents: knowledgeBaseDocuments,
          },
    };
    formData.append("request_json", JSON.stringify(jsonPayload));
    console.log(formData);
    
    // Track temp files for cleanup
    const tempFilesToCleanup = [];
    
    // Check if generated content documents are selected
    const hasGeneratedContent = docList.some(selectedValue => {
      const doc = docOptions
        .flatMap(group => group.options || [])
        .find(option => option.value === selectedValue);
      return doc && doc.source === 'generated_contents';
    });
    
    // Check if files are uploaded initially
    let hasFilesToUpload = allUploadedFiles.length > 0;
    
    try {
      // Process Google integrations before uploading files
      const googleIntegrations = integrations.filter(integration => {
        const type = integration.type?.toLowerCase() || '';
        const configType = integration.config?.integration_type?.toLowerCase() || '';
        return type.includes('google') || configType.includes('google');
      });
      
      if (googleIntegrations.length > 0) {
        for (const integration of googleIntegrations) {
          try {
            const { fields } = integration;
            const sheetUrl = fields?.sheet_url || fields?.sheetUrl;
            const dataRange = fields?.data_range || fields?.dataRange;
            const customInstruction = fields?.custom_instructions || fields?.customInstructions || fields?.custom_instruction;
            const action = fields?.action;
            
            if (sheetUrl) {
              const actions = action ? [action] : [];
              const sheetData = await fetchGoogleSheetsData({
                sheet_url: sheetUrl,
                data_range: dataRange || '',
                custom_instruction: customInstruction || '',
                actions: actions
              });
              
              // Download the file from download_url
              if (sheetData?.download_url) {
                try {
                  const authToken = localStorage.getItem('token');
                  const downloadResponse = await fetch(sheetData.download_url, {
                    headers: authToken ? { 'Authorization': authToken } : {},
                  });
                  
                  if (!downloadResponse.ok) {
                    throw new Error(`Failed to download file: ${downloadResponse.status}`);
                  }
                  
                  const blob = await downloadResponse.blob();
                  const contentType = downloadResponse.headers.get('content-type') || blob.type || '';
                  const fileExtension = contentType.includes('csv') || contentType.includes('text/csv') 
                    ? 'csv' 
                    : contentType.includes('xlsx') || contentType.includes('spreadsheetml')
                    ? 'xlsx'
                    : 'xlsx';
                  const fileName = `google_sheets_${Date.now()}.${fileExtension}`;
                  const file = new File([blob], fileName, { 
                    type: contentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
                  });
                  
                  // Add to formData
                  formData.append("file[]", file);
                  tempFilesToCleanup.push(file);
                  hasFilesToUpload = true; // Mark that we have files from Google integration
                  
                  toast.success(`Successfully fetched and added Google Sheets data`);
                } catch (downloadError) {
                  console.error('Error downloading Google Sheets file:', downloadError);
                  toast.error(`Failed to download Google Sheets file: ${downloadError.message}`);
                }
              } else {
                toast.success(`Successfully fetched data from Google Sheets`);
              }
            }
          } catch (error) {
            console.error('Error fetching Google Sheets data:', error);
            toast.error(`Failed to fetch data from Google Sheets: ${error.message}`);
          }
        }
      }
      
      // Skip API call only if: no files AND no generated content (i.e., only scraped URLs)
      // Call API if: files uploaded OR generated content selected OR files from Google integrations
      let response = null;
      if (hasFilesToUpload || hasGeneratedContent) {
        // Helper function to get blog folder ID from agent instructions
        const getBlogFolderId = () => {
          try {
            const agentIntegrations = localStorage.getItem('agent_integrations');
            if (!agentIntegrations) return null;
            
            const integrations = JSON.parse(agentIntegrations);
            // Extract folder ID directly from Blog_knowledge_base (flat structure)
            return integrations?.Blog_knowledge_base || null;
          } catch (error) {
            console.error('Error getting blog folder ID:', error);
            return null;
          }
        };
        
        // For DIY agents, use the fouray/upload API with folder ID
        if (isDiyAgentFlow && agentData && hasFilesToUpload) {
          // Extract folder ID from agent data
          const folderId = agentData?.knowledge_base_dim3?.knowledge_bases?.[0]?.knowledgeBase?.[0];
          
          if (folderId) {
            response = await uploadFilesToFouray(allUploadedFiles, folderId);
          } else {
            console.warn('DIY agent folder ID not found, skipping upload');
            response = null;
          }
        } 
        // For blog flow, use the fouray/upload API with folder ID from agent instructions
        else if (isBlogFlow && hasFilesToUpload) {
          const blogFolderId = getBlogFolderId();
          
          if (blogFolderId) {
            response = await uploadFilesToFouray(allUploadedFiles, blogFolderId);
          } else {
            console.warn('Blog folder ID not found in agent instructions, skipping upload');
            response = null;
          }
        } 
        else {
          // Use regular upload API for other flows (email, free form, chat, product description)
          response = await uploadFilesToApi(formData);
        }
      }
      if (location.pathname == "/skills/blog") {
        onHide();
        handleAfterModal(response);
      } else if (isBlogFlow) {
        onHide();
        return;
      } else if (isFreeFormContentFlow) {
        if (editingRowData) {
          handleScrapingAndNavigate(generatedUID || uid, true, true); // Enable scraping on submit
        } else {
          navigate('/skills/free-form-content/create', {
            state: {
              tags: tagList.join(", "),
              documents: docList,
              uid: generatedUID || uid,
              uploadedFiles: allUploadedFiles,
            }
          });
        }
        return; 
      } else if (isChatFlow) {
        navigate('/skills/chat/chat_bot', {
          state: {
            tags: tagList.join(", "),
            documents: docList,
           
            uploadedFiles: allUploadedFiles, 
            uid: editingRowData?.uid || generateUID(),
            agentId: editingRowData?.agent_id || "",
            sessionId: editingRowData?.session_id || "",
            chatId: editingRowData?.id || "",
            chatTitle: editingRowData?.name || "",
          }
        });
        return;
      } else if (isDiyAgentFlow && agentData) {
        // For DIY agents, navigate to dynamic playground
        // Content type will be detected in the playground based on API response
        const agentSlug = agentData.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        
        onHide();
        navigate(`/skills/${agentSlug}/playground`, {
          state: {
            agentData,
            agentName: agentData.name,
            tags: tagList.join(", "),
            documents: docList,
            uid: generatedUID || uid,
            uploadedFiles: allUploadedFiles,
          },
        });
        return;
      } else if (location.pathname === "/skills/email/email-template") {
          navigate("/skills/email/create-email", {
            state: {
              productData,
              previewUrl,
              sku,
              templateName: formatedTemplateName,
              templateId,
              previewImage,
              tags: tagList.join(", "),
              uid: generatedUID || uid,
            },
          });
        } else if (location.pathname === "/skills/product-description") {
          // Navigate with product ID in URL if available, otherwise use base route
          const isShopifyProduct = productData?.source === "Shopify";
          const productId = productData?.id;
          const navigationPath = isShopifyProduct
            ? "/edit-product-description"
            : `/edit-product-description/${productId}`;
          
          navigate(navigationPath, {
            state: {
              productData,
              sku,
              tags: tagList.join(", "),
            },
          });
        }
        onHide();
    } catch (error) {
      console.error("Upload failed:", error);
      if (error.response && error.response.data) {
        alert(error.response.data.error || JSON.stringify(error.response.data));
      } else {
        alert(error.message || "File upload failed. Please try again.");
      }
      
      // Clean up temp files on error
      tempFilesToCleanup.forEach(file => {
        // Files in memory will be garbage collected, but we can explicitly clear references
        try {
          if (file && typeof file.close === 'function') {
            file.close();
          }
        } catch (cleanupError) {
          console.warn('Error cleaning up temp file:', cleanupError);
        }
      });
    } finally {
      setIsUploading(false);
      // Clear temp files references after successful upload
      tempFilesToCleanup.length = 0;
    }
  };

  const onSkipStep = async () => {
    // Generate UID if it doesn't exist
    let generatedUID = uid;
    if (!generatedUID) {
      generatedUID = generateUID();
    }

    // Handle DIY agent flow - navigate to playground
    if (isDiyAgentFlow && agentData) {
      // Content type will be detected in the playground based on API response
      const agentSlug = agentData.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
      
      onHide();
      navigate(`/skills/${agentSlug}/playground`, {
        state: {
          agentData,
          agentName: agentData.name,
          tags: tagList.join(", "),
          documents: docList,
          uid: generatedUID,
          uploadedFiles: [],
        },
      });
      return;
    }

    const isBlogFlow = location.pathname == "/skills/blog";
    if (isBlogFlow) {
      onHide();
      handleAfterModal(null, generatedUID);
      return;
    } else if (location.pathname.includes("/skills/blog")) {
      onHide();
      return;
      } else if (isFreeFormContentFlow) {
        if (editingRowData) {
          handleScrapingAndNavigate(uid, true, false); // Skip scraping on skip
        } else {
          navigate('/skills/free-form-content/create', {
            state: {
              tags: tagList.join(", "),
              documents: docList,
              uid: generatedUID,
              uploadedFiles: [],
            }
          });
        }
        return;
    } else if (isChatFlow) {
      navigate('/skills/chat/chat_bot', {
        state: {
          tags: tagList.join(", "),
          documents: docList,
          uid: editingRowData?.uid || generateUID(),
          agentId: editingRowData?.agent_id|| "",
          sessionId: editingRowData?.session_id|| "",
          chatId: editingRowData?.id|| "",
          chatTitle: editingRowData?.name|| "",
          uploadedFiles: [],
        }
      });
      return;
    }
    // Check if the current path is '/skills/email/email-template'
    if (location.pathname === "/skills/email/email-template") {
      navigate("/skills/email/create-email", {
        state: {
          productData: productData,
          sku: sku,
          templateName: formatedTemplateName,
          previewUrl: previewUrl,
          templateId: templateId,
          previewImage: previewImage,
          tags: document.tags || "",
        },
      });
    } else if (location.pathname === "/skills/product-description") {
      // Navigate with product ID in URL if available, otherwise use base route
      const isShopifyProduct = productData?.source === "Shopify";
      const productId = productData?.id;
      const navigationPath = isShopifyProduct
        ? "/edit-product-description"
        : `/edit-product-description/${productId}`;
      
      navigate(navigationPath, {
        state: {
          productData,
          sku,
          tags: tagList.join(", "),
        },
      });
    }
  };
  // Create document options - use grouped if available, otherwise fallback to flat
  const docOptions = groupedDocuments.length > 0 
    ? groupedDocuments 
    : companyKnowledgeDocs.length > 0 
    ? companyKnowledgeDocs.map((doc, index) => {
        // Handle different data structures from API
        const docValue = doc.value || doc.url || doc.name || doc;
        const docLabel = doc.label || doc.name || (typeof doc === 'string' ? doc.split("/").pop() : `Document ${index + 1}`);
        
        return {
          value: docValue,
          label: docLabel,
          source: doc.source || 'knowledge_base',
          contentType: doc.contentType || null
        };
      })
    : [];

  // Filter documents based on search term
  const filteredDocOptions = React.useMemo(() => {
    if (!searchTerm.trim()) {
      return docOptions;
    }

    return docOptions.map(group => ({
      ...group,
      options: group.options.filter(option =>
        option.label.toLowerCase().includes(searchTerm.toLowerCase())
      )
    })).filter(group => group.options.length > 0);
  }, [docOptions, searchTerm]);

  // Extract resource type and ID from selected generated content documents
  const getResourceInfo = () => {
    const selectedGeneratedDocs = docList
      .map(selectedValue => {
        return docOptions
          .flatMap(group => group.options || [])
          .find(option => option.value === selectedValue);
      })
      .filter(doc => doc && doc.source === 'generated_contents');

    if (selectedGeneratedDocs.length > 0) {
      const firstDoc = selectedGeneratedDocs[0];
      const resourceId = firstDoc.value || firstDoc.id;
      
      const numericId = resourceId ? resourceId.toString().split('_').pop() : null;
      
      return {
        resource_type: firstDoc.contentType,
        resource_id: numericId
      };
    }
    return null;
  };

  const handleAfterModal = (response, overrideUid = null) => {
    // Use overrideUid if provided, otherwise fall back to blogData.uid
    const finalUid = overrideUid || blogData?.uid || "";
    
    if (blogData?.final_blog && Object.keys(blogData.final_blog).length > 0) {
      navigate("/skills/blog/blog-playground", {
        state: {
          formData: {
            about: blogData.about || "",
            tone: blogData.tone || "",
            word_limit: blogData.word_limit || "",
            location: blogData.location || "",
            language: blogData.language || "",
            further_details: blogData.further_details || "",
            brand_context: blogData.brand_context || {},
            session_id: blogData.session_id || "",
            agent_id: blogData.agent_id || "",
            uid: finalUid,
            semantic_clusters: blogData.keyword_clusters || [],
          },
          blogOutline: blogData.outlines || {},
          finalBlog: blogData.final_blog, // Pass the generated blog data
          blogId: blogData.id || blogData.blog_id || null, // Pass the blog ID if available
        },
      });
    } else if (
      blogData?.outlines &&
      Object.keys(blogData.outlines).length > 0
    ) {
      navigate("/skills/blog/generate-blog", {
        state: {
          formData: {
            blogId: blogData.id,
            about: blogData.about,
            location: blogData.location,
            language: blogData.language,
            further_details: blogData.further_details,
            word_limit: blogData.word_limit,
            tone: blogData.tone,
            session_id: blogData.session_id,
            agent_id: blogData.agent_id,
            uid: finalUid,
            semantic_clusters: blogData.keyword_clusters || "[]",
          },
          blogOutline: blogData.outlines || "{}",
          isEditMode: true,
        },
      });
    } else {
      setTimeout(() => setShowBlogTypeModal(true), 300);
      setBlogTypeModalData(response);
    }
    return;
  };

  return (
    <>
      <Modal
        show={show}
        onHide={isScrapingForEdit ? undefined : onHide}
        centered
        className="document-upload-modal"
        backdrop={isScrapingForEdit ? 'static' : true}
        keyboard={!isScrapingForEdit}
      >
        <Modal.Header>
          <Modal.Title>
            {isBlogFlow 
              ? "Upload documents for Blog" 
              : isEmailFlow 
              ? "Upload documents for Email" 
              : isFreeFormContentFlow 
              ? (editingRowData ? `Upload documents for editing "${editingRowData.name || editingRowData.title}"` : "Upload documents for Free Form Content")
              : isChatFlow
              ? "Upload documents for Chat"
              : "Upload documents for Product Description"
            }
          </Modal.Title>
          <button 
            className="close-button" 
            onClick={onHide}
            disabled={isScrapingForEdit}
            style={{ opacity: isScrapingForEdit ? 0.5 : 1, cursor: isScrapingForEdit ? 'not-allowed' : 'pointer' }}
          >
            <X size={18} color="black" />
          </button>
        </Modal.Header>

        <Modal.Body>
          <p className="modal-description" style={{ color: "black" }}>
            Select relevant documents from your knowledge base and generated contents
          </p>

          <div className="search-section">
            {/* Custom Dropdown */}
            <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
              {/* Dropdown Trigger */}
              <div
                style={{
                  border: '2px solid #1976d2',
                  borderRadius: '4px',
                  padding: '8px 12px',
                  backgroundColor: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  minHeight: '38px',
                  flexWrap: 'wrap',
                  gap: '4px'
                }}
              >
                <div style={{ 
                  display: 'flex', 
                  flexWrap: 'wrap', 
                  gap: '4px', 
                  flex: 1,
                  alignItems: 'center',
                  minWidth: 0
                }}>
                  {docList.length > 0 && (
                    docList.map((selectedValue, index) => {
                      // Find the selected document from all groups
                      const selectedDoc = docOptions
                        .flatMap(group => group.options || [])
                        .find(option => option.value === selectedValue);
                      
                      return selectedDoc ? (
                        <span
                          key={index}
                          style={{
                            backgroundColor: '#f5f5f5',
                            color: '#333',
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '4px',
                            maxWidth: '200px',
                            border: '1px solid #e0e0e0',
                            flexShrink: 0
                          }}
                        >
                          <span 
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              position: 'relative'
                            }}
                            title={selectedDoc.label}
                            onMouseEnter={() => setHoveredItem(selectedValue)}
                            onMouseLeave={() => setHoveredItem(null)}
                          >
                            {selectedDoc.label}
                            {hoveredItem === selectedValue && (
                              <div style={{
                                position: 'absolute',
                                top: '-35px',
                                left: '0',
                                backgroundColor: '#333',
                                color: '#fff',
                                padding: '6px 8px',
                                borderRadius: '4px',
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                                zIndex: 1001,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                maxWidth: '300px',
                                wordBreak: 'break-word'
                              }}>
                                {selectedDoc.label}
                                <div style={{
                                  position: 'absolute',
                                  top: '100%',
                                  left: '10px',
                                  width: 0,
                                  height: 0,
                                  borderLeft: '5px solid transparent',
                                  borderRight: '5px solid transparent',
                                  borderTop: '5px solid #333'
                                }}></div>
                              </div>
                            )}
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              setDocList(prev => prev.filter(val => val !== selectedValue));
                            }}
                            style={{
                              cursor: 'pointer',
                              fontSize: '14px',
                              fontWeight: 'bold',
                              marginLeft: '4px',
                              color: '#666'
                            }}
                          >
                            ×
                          </span>
                        </span>
                      ) : null;
                    })
                  )}
                  <div style={{ position: 'relative', flex: 1, minWidth: '200px' }}>
                    <input
                      type="text"
                      placeholder={docList.length === 0 ? "Select documents from knowledge base and generated contents..." : "Search documents..."}
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onFocus={() => setIsDropdownOpen(true)}
                      style={{
                        width: '100%',
                        border: 'none',
                        outline: 'none',
                        fontSize: '14px',
                        color: '#333',
                        backgroundColor: 'transparent',
                        paddingRight: searchTerm ? '25px' : '0'
                      }}
                    />
                    {searchTerm && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          setSearchTerm('');
                        }}
                        style={{
                          position: 'absolute',
                          right: '0',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                          fontSize: '16px',
                          color: '#666',
                          padding: '2px'
                        }}
                      >
                        ×
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {docList.length > 0 && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setDocList([]);
                      }}
                      style={{
                        cursor: 'pointer',
                        fontSize: '16px',
                        color: '#666',
                        padding: '2px'
                      }}
                    >
                      ×
                    </span>
                  )}
                  <span style={{ 
                    fontSize: '12px', 
                    color: '#666',
                    transform: isDropdownOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }}>
                    ▼
                  </span>
                </div>
              </div>

              {/* Dropdown Menu */}
              {isDropdownOpen && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#fff',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  zIndex: 1000,
                  maxHeight: '300px',
                  overflowY: 'auto',
                  overflowX: 'hidden'
                }}>

                  {filteredDocOptions.length > 0 ? (
                    filteredDocOptions.map((group, groupIndex) => (
                      <div key={groupIndex}>
                        {/* Group Header */}
                        <div
                          onClick={() => toggleGroup(group.label)}
                          style={{
                            padding: '12px 16px',
                            backgroundColor: '#f8f9fa',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            borderBottom: '1px solid #e0e0e0',
                            userSelect: 'none'
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ 
                              fontSize: '14px', 
                              fontWeight: '600', 
                              color: '#333' 
                            }}>
                              {group.label}
                            </span>
                            <span style={{ 
                              fontSize: '12px', 
                              color: '#666',
                              backgroundColor: '#e9ecef',
                              padding: '2px 8px',
                              borderRadius: '12px'
                            }}>
                              {group.options.length}
                            </span>
                          </div>
                          <span style={{ 
                            fontSize: '12px', 
                            color: '#666',
                            transform: expandedGroups[group.label] ? 'rotate(90deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease'
                          }}>
                            ▶
                          </span>
                        </div>

                        {/* Group Content */}
                        {expandedGroups[group.label] && (
                          <div style={{ backgroundColor: '#fff' }}>
                            {group.options.map((option, optionIndex) => {
                              // Check if this option is from generated_contents
                              const isGeneratedContent = option.source === 'generated_contents';
                              
                              return (
                              <div
                                key={optionIndex}
                                onClick={() => {
                                  const isSelected = docList.includes(option.value);
                                  if (isSelected) {
                                    // Remove the selected document
                                    setDocList(prev => prev.filter(val => val !== option.value));
                                  } else {
                                    // If selecting a generated content document, remove all other generated content documents first
                                    if (isGeneratedContent) {
                                      // Get all document options to find which ones are generated content
                                      const allOptions = docOptions.flatMap(group => group.options || []);
                                      const generatedContentValues = allOptions
                                        .filter(opt => opt.source === 'generated_contents')
                                        .map(opt => opt.value);
                                      
                                      // Remove all generated content documents and add the new one
                                      setDocList(prev => {
                                        const filtered = prev.filter(val => !generatedContentValues.includes(val));
                                        return [...filtered, option.value];
                                      });
                                    } else {
                                      // For knowledge base documents, allow multi-select
                                      setDocList(prev => [...prev, option.value]);
                                    }
                                  }
                                }}
                                style={{
                                  padding: '12px 16px',
                                  cursor: 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'space-between',
                                  backgroundColor: docList.includes(option.value) ? '#e3f2fd' : 'transparent',
                                  borderLeft: docList.includes(option.value) ? '3px solid #1976d2' : '3px solid transparent',
                                  transition: 'all 0.2s ease',
                                  borderBottom: '1px solid #f0f0f0',
                                  overflow: 'hidden',
                                  minWidth: 0
                                }}
                                onMouseEnter={(e) => {
                                  if (!docList.includes(option.value)) {
                                    e.target.style.backgroundColor = '#f0f8ff';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!docList.includes(option.value)) {
                                    e.target.style.backgroundColor = 'transparent';
                                  }
                                }}
                              >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: 1 }}>
                                  {docList.includes(option.value) && (
                                    <span style={{ 
                                      fontSize: '12px', 
                                      color: '#1976d2',
                                      fontWeight: 'bold'
                                    }}>
                                      ✓
                                    </span>
                                  )}
                                  <span 
                                    style={{ 
                                      flex: 1, 
                                      fontSize: '14px',
                                      color: docList.includes(option.value) ? '#1976d2' : '#333',
                                      fontWeight: docList.includes(option.value) ? '500' : '400',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      cursor: 'pointer',
                                      position: 'relative'
                                    }}
                                    title={option.label}
                                    onMouseEnter={() => setHoveredItem(option.value)}
                                    onMouseLeave={() => setHoveredItem(null)}
                                  >
                                    {option.label}
                                    {hoveredItem === option.value && (
                                      <div style={{
                                        position: 'absolute',
                                        top: '-35px',
                                        left: '0',
                                        backgroundColor: '#333',
                                        color: '#fff',
                                        padding: '6px 8px',
                                        borderRadius: '4px',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                        zIndex: 1001,
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                        maxWidth: '300px',
                                        wordBreak: 'break-word'
                                      }}>
                                        {option.label}
                                        <div style={{
                                          position: 'absolute',
                                          top: '100%',
                                          left: '10px',
                                          width: 0,
                                          height: 0,
                                          borderLeft: '5px solid transparent',
                                          borderRight: '5px solid transparent',
                                          borderTop: '5px solid #333'
                                        }}></div>
                                      </div>
                                    )}
                                  </span>
                                </div>
                                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                  {option.contentType && option.contentType !== group.label && (
                                    <span 
                                      style={{ 
                                        fontSize: '9px', 
                                        padding: '2px 6px', 
                                        borderRadius: '8px',
                                        backgroundColor: '#f0f0f0',
                                        color: '#666',
                                        fontWeight: '400'
                                      }}
                                    >
                                      {option.contentType}
                                    </span>
                                  )}
                                </div>
                              </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    <div style={{ 
                      padding: '20px', 
                      textAlign: 'center', 
                      color: '#666',
                      fontStyle: 'italic'
                    }}>
                      {searchTerm.trim() ? 'No documents found matching your search' : 'No documents available'}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="divider">
            <span>Or</span>
          </div>

          <div
            {...getRootProps1({ className: "upload-zone" })}
            onClick={() => openFileDialog(fileInputRef1)}
          >
            <input
              {...getInputProps1()}
              type="file"
              multiple
              accept=".pdf,.txt,.doc,.csv,.png,.jpg,.jpeg"
              onChange={(event) => handleFileSelect(event, setUploadedFiles1)}
              style={{
                display: "none",
              }}
              ref={fileInputRef1}
            />
            <img
              src="/upload-file-dark.svg"
              alt=""
              height={24}
              width={24}
              className="upload-icon"
            />
            <p className="upload-text">
              Drag and drop files, or{" "}
              <span className="browse-text">Browse</span>
            </p>
            <p className="file-types">
              Supported formats: PDFs, TXT, DOC, CSV, PNG, JPG, JPEG
            </p>
          </div>

          {uploadedFiles1.length > 0 && (
            <div className="uploaded-files">
              {uploadedFiles1.map((file, index) => (
                <div key={index} className="uploaded-file">
                  <div className="d-flex justify-content-center align-items-center gap-3 flex-grow-1">
                    <img
                      src={getFileIcon(file.type)}
                      alt="File"
                      className="file-icon"
                    />
                    <div className="file-details">
                      <p className="file-name">{shortenFileName(file.name)}</p>
                      <span style={{ fontSize: "14px", color: "#6B7280" }}>
                        {getFileSize(file)}
                      </span>
                    </div>
                  </div>
                  <button
                    onClick={() => handleRemoveFile1(index, setUploadedFiles1)}
                    className="remove-file-button"
                  >
                    <CircleX size={18} />
                  </button>
                </div>
              ))}
            </div>
          )}

         {/*  <div className="section">
            <h6
              className="section-title"
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              Add industry data/trends
            </h6>
            <div
              {...getRootProps2({ className: "upload-zone" })}
              onClick={() => openFileDialog(fileInputRef2)}
            >
              <input
                {...getInputProps2()}
                type="file"
                multiple
                accept=".pdf,.txt,.doc,.csv,.png,.jpg,.jpeg"
                onChange={(event) => handleFileSelect(event, setUploadedFiles2)}
                style={{
                  display: "none",
                }}
                ref={fileInputRef2}
              />
              <img
                src="/upload-file-dark.svg"
                alt=""
                height={24}
                width={24}
                className="upload-icon"
              />
              <p className="upload-text">
                Drag and drop files, or{" "}
                <span className="browse-text">Browse</span>
              </p>
              <p className="file-types">
                Supported formats: PDFs, TXT, DOC, CSV, PNG, JPG, JPEG
              </p>
            </div>
            {uploadedFiles2.length > 0 && (
              <div className="uploaded-files">
                {uploadedFiles2.map((file, index) => (
                  <div key={index} className="uploaded-file">
                    <div className="d-flex justify-content-center align-items-center gap-3 flex-grow-1">
                      <img
                        src={getFileIcon(file.type)}
                        alt="File"
                        className="file-icon"
                      />
                      <div className="file-details">
                        <p className="file-name">
                          {shortenFileName(file.name)}
                        </p>
                        <span style={{ fontSize: "14px", color: "#6B7280" }}>
                          {getFileSize(file)}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={() =>
                        handleRemoveFile2(index, setUploadedFiles2)
                      }
                      className="remove-file-button"
                    >
                      <CircleX size={18} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>*/}
 {/* Integration Configuration Section */}
 <div className="section">
            <h6
              className="section-title"
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              Fetch data from third party integrations
            </h6>
            
            <div style={{ marginBottom: '16px' }}>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '16px' }}>
                <div style={{ flex: 1 }}>
                  <Select
                    value={integrationOptions.find(opt => opt.value === selectedIntegration) || null}
                    onChange={handleIntegrationSelect}
                    options={integrationOptions}
                    placeholder="Select Integration"
                    styles={{
                      control: (base) => ({
                        ...base,
                        border: '2px solid #1976d2',
                        borderRadius: '4px',
                        minHeight: '38px',
                        fontSize: '14px',
                        boxShadow: 'none',
                        '&:hover': {
                          border: '2px solid #1976d2',
                        }
                      }),
                      placeholder: (base) => ({
                        ...base,
                        color: '#6c757d',
                        fontSize: '14px'
                      }),
                      indicatorsContainer: () => ({
                        display: 'none'
                      }),
                      indicatorSeparator: () => ({
                        display: 'none'
                      })
                    }}
                  />
                </div>
                <button
                  className="btn btn-primary"
                  style={{
                    backgroundColor: '#7c3aed',
                    borderColor: '#7c3aed',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '500'
                  }}
                  onClick={handleConfigureIntegration}
                  disabled={!selectedIntegration || isLoadingIntegration}
                >
                  {isLoadingIntegration ? (
                    <>
                      <Loader2 size={16} className="animate-spin mr-2" />
                      Loading...
                    </>
                  ) : (
                    'Configure'
                  )}
                </button>
              </div>

              {/* Integration Configuration Forms */}
              {integrations.map((integration) => (
                <div key={integration.id} style={{
                  border: '1px solid #e0e0e0',
                  borderRadius: '8px',
                  padding: '16px',
                  backgroundColor: '#f8f9fa',
                  marginBottom: '16px'
                }}>
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    marginBottom: '16px'
                  }}>
                    <h6 style={{ margin: 0, color: '#333', fontWeight: '600' }}>
                      {integrationOptions.find(opt => opt.value === integration.type)?.label}
                    </h6>
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => removeIntegration(integration.id)}
                      style={{ 
                        color: 'red', 
                        textDecoration: 'none',
                        padding: '4px 8px',
                        fontSize: '14px'
                      }}
                    >
                      Remove
                    </button>
                  </div>

                  {integration.config.fields.map((field) => (
                    <div key={field.id} style={{ marginBottom: '16px' }}>
                      <label style={{ 
                        display: 'block', 
                        marginBottom: '4px', 
                        fontWeight: '500',
                        color: '#333'
                      }}>
                        {field.label}
                        {field.required && <span style={{ color: 'red' }}> *</span>}
                      </label>
                      
                      {field.type === 'select' ? (
                        <Select
                          value={field.options?.find(opt => opt.value === (integration.fields[field.id] || '')) || null}
                          onChange={(selectedOption) => handleIntegrationFieldChange(integration.id, field.id, selectedOption?.value || '')}
                          options={field.options || []}
                          placeholder={`Select ${field.label}`}
                          styles={{
                            control: (base, state) => {
                              const isEmpty = !integration.fields[field.id] || integration.fields[field.id].toString().trim() === '';
                              const hasError = showFieldValidation && field.required && isEmpty;
                              
                              return {
                                ...base,
                                border: hasError ? '1px solid #dc3545' : '1px solid #ddd',
                                borderRadius: '4px',
                                minHeight: '38px',
                                fontSize: '14px',
                                boxShadow: 'none',
                                '&:hover': {
                                  border: hasError ? '1px solid #dc3545' : '1px solid #ddd',
                                },
                                ...(state.isFocused && {
                                  border: hasError ? '1px solid #dc3545' : '1px solid #1976d2',
                                  boxShadow: hasError ? '0 0 0 0.2rem rgba(220, 53, 69, 0.25)' : '0 0 0 0.2rem rgba(25, 118, 210, 0.25)'
                                })
                              };
                            },
                            placeholder: (base) => ({
                              ...base,
                              color: '#6c757d',
                              fontSize: '14px'
                            }),
                            indicatorsContainer: () => ({
                              display: 'none'
                            }),
                            indicatorSeparator: () => ({
                              display: 'none'
                            })
                          }}
                        />
                      ) : field.type === 'textarea' ? (
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={integration.fields[field.id] || ''}
                          onChange={(e) => handleIntegrationFieldChange(integration.id, field.id, e.target.value)}
                          placeholder={field.placeholder}
                          style={{
                            border: (showFieldValidation && field.required && (!integration.fields[field.id] || integration.fields[field.id].toString().trim() === '')) 
                              ? '1px solid #dc3545' 
                              : '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '8px 12px',
                            fontSize: '14px',
                            resize: 'vertical'
                          }}
                        />
                      ) : (
                        <Form.Control
                          type={field.type}
                          value={integration.fields[field.id] || ''}
                          onChange={(e) => handleIntegrationFieldChange(integration.id, field.id, e.target.value)}
                          placeholder={field.placeholder}
                          style={{
                            border: (showFieldValidation && field.required && (!integration.fields[field.id] || integration.fields[field.id].toString().trim() === '')) 
                              ? '1px solid #dc3545' 
                              : '1px solid #ddd',
                            borderRadius: '4px',
                            padding: '8px 12px',
                            fontSize: '14px'
                          }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <div className="section">
            <h6
              className="section-title"
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              Competition / Reference URLs
            </h6>

            <div>
              {referenceUrls.map((url, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <Form.Control
                    type="text"
                    placeholder="https://url-example.com/product"
                    className="styled-input"
                    value={url}
                    onChange={(e) => {
                      const newUrls = [...referenceUrls];
                      newUrls[idx] = e.target.value;
                      setReferenceUrls(newUrls);
                      // keep arrays in sync
                      if (scrapingLoadingArr.length < newUrls.length)
                        setScrapingLoadingArr([...scrapingLoadingArr, false]);
                      if (scrapingSuccessArr.length < newUrls.length)
                        setScrapingSuccessArr([...scrapingSuccessArr, false]);
                    }}
                  />
                  <button
                    type="button"
                    className={
                      scrapingSuccessArr[idx]
                        ? "btn btn-light btn-sm py-0 px-2 rounded"
                        : "btn btn-dark btn-sm py-0 px-2 rounded"
                    }
                    style={{
                      marginLeft: 4,
                      color: scrapingSuccessArr[idx] ? "green" : "#fff",
                      backgroundColor: scrapingSuccessArr[idx]
                        ? "#fff"
                        : "#212529",
                      border: "1px solid #000",
                      fontWeight: 500,
                      minWidth: 60,
                    }}
                    onClick={() => handleScrapAtIndex(idx)}
                  >
                    {scrapingLoadingArr[idx] ? (
                      <Loader2 size={16} className="animate-spin" />
                    ) : scrapingSuccessArr[idx] ? (
                      <Check size={16} color="green" />
                    ) : (
                      <span style={{ color: "#fff" }}>Scrape</span>
                    )}
                  </button>
                  <button
                    type="button"
                    className="btn btn-link"
                    style={{ color: "red", marginLeft: 4 }}
                    onClick={() => {
                      setReferenceUrls(
                        referenceUrls.filter((_, i) => i !== idx)
                      );
                      setScrapingLoadingArr(
                        scrapingLoadingArr.filter((_, i) => i !== idx)
                      );
                      setScrapingSuccessArr(
                        scrapingSuccessArr.filter((_, i) => i !== idx)
                      );
                    }}
                    disabled={scrapingLoadingArr[idx]}
                  >
                    Remove
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="btn btn-link"
                onClick={() => {
                  setReferenceUrls([...referenceUrls, ""]);
                  setScrapingLoadingArr([...scrapingLoadingArr, false]);
                  setScrapingSuccessArr([...scrapingSuccessArr, false]);
                }}
              >
                + Add another URL
              </button>
            </div>
          </div>

          {/* Meta Tags Section */}
          <div className="section">
            <h6
              className="section-title"
              style={{
                borderBottom: "1px solid #e0e0e0",
                paddingBottom: "8px",
              }}
            >
              Meta Tags
            </h6>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                marginBottom: "12px",
              }}
            >
              {tagList.map((tag, index) => (
                <span
                  key={index}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "5px 10px",
                    borderRadius: "12px",
                    fontSize: "14px",
                    backgroundColor: "#212529",
                    color: "white",
                  }}
                >
                  {tag}
                  <button
                    onClick={() => handleRemoveTag(index)}
                    style={{
                      background: "none",
                      border: "none",
                      marginLeft: "8px",
                      color: "white",
                      cursor: "pointer",
                    }}
                  >
                    <CircleX size={14} />
                  </button>
                </span>
              ))}
            </div>

            <div className="input-wrapper mt-2">
              <Tag size={20} className="input-icon" />
              <Form.Control
                type="text"
                placeholder="Add tags"
                className="form-control"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
                onKeyDown={handleTagInput}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-center">
          <div className="d-flex flex-column align-items-center gap-2">
            <button
              className="next-button"
              onClick={handleFileUpload}
              disabled={isUploading || isScrapingForEdit}
              style={{ width: "200px" }}
            >
              {isUploading ? (
                <Loader2 size={16} className="animate-spin mr-2" />
              ) : isScrapingForEdit ? (
                <>
                  <Loader2 size={16} className="animate-spin mr-2" />
                  Scraping...
                </>
              ) : (
                "Next"
              )}
            </button>
            <button 
              className="skip-button" 
              onClick={onSkipStep}
              disabled={isScrapingForEdit}
            >
              {isScrapingForEdit ? "Scraping..." : "Skip this step"}
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <BlogTypeModal
        show={showBlogTypeModal}
        onClose={() => setShowBlogTypeModal(false)}
        data={blogTypeModalData}
        uid={uid}
      />
    </>
  );
};

export default DocumentModal;
